import React from 'react';

const Burst12 = (props) => {
    const { color } = props;

    return (
        <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 117 117"
            style={{
                enableBackground: 'new 0 0 117 117',
                width: '100%',
            }}
            xmlSpace="preserve"
        >
            <path
                style={{ fill: `${color}` }}
                id="Path_3734-2"
                d="M69.3,2.6c0.8-0.9,2.2-1,3.1-0.1c0.3,0.3,0.5,0.6,0.6,1l3.9,13c0.3,1.2,1.6,1.8,2.7,1.5
	c0.1,0,0.1,0,0.2-0.1l12.6-5.1c1.1-0.5,2.4,0.1,2.9,1.2c0.1,0.4,0.2,0.8,0.1,1.2l-2.1,13.4c-0.2,1.2,0.6,2.3,1.8,2.5
	c0.1,0,0.1,0,0.2,0l13.5,0.9c1.2,0.1,2.1,1.1,2.1,2.3c0,0.4-0.2,0.8-0.4,1.1l-7.7,11.2c-0.7,1-0.4,2.4,0.6,3.1
	c0.1,0,0.1,0.1,0.2,0.1l11.8,6.7c1.1,0.6,1.4,1.9,0.8,3c-0.2,0.3-0.5,0.6-0.8,0.8l-11.8,6.7c-1.1,0.6-1.4,1.9-0.8,3
	c0,0.1,0.1,0.1,0.1,0.2l7.7,11.2c0.7,1,0.4,2.4-0.6,3.1c-0.3,0.2-0.7,0.4-1.1,0.4l-13.5,0.9c-1.2,0.1-2.1,1.1-2.1,2.3
	c0,0.1,0,0.1,0,0.2l2.1,13.4c0.2,1.2-0.6,2.3-1.8,2.5c-0.4,0.1-0.8,0-1.2-0.1l-12.6-5.1c-1.1-0.5-2.4,0.1-2.9,1.2
	c0,0.1,0,0.1-0.1,0.2l-3.9,13c-0.3,1.2-1.6,1.8-2.7,1.5c-0.4-0.1-0.7-0.3-1-0.6l-9.1-10c-0.8-0.9-2.2-1-3.1-0.1
	c-0.1,0-0.1,0.1-0.1,0.1l-9.1,10c-0.8,0.9-2.2,1-3.1,0.1c-0.3-0.3-0.5-0.6-0.6-1l-3.9-13c-0.3-1.2-1.6-1.8-2.7-1.5
	c-0.1,0-0.1,0-0.2,0.1l-12.6,5.1c-1.1,0.5-2.4-0.1-2.9-1.2c-0.1-0.4-0.2-0.8-0.1-1.2l2.1-13.4c0.2-1.2-0.6-2.3-1.8-2.5
	c-0.1,0-0.1,0-0.2,0L8.2,84.9c-1.2-0.1-2.1-1.1-2.1-2.3c0-0.4,0.2-0.8,0.4-1.1l7.7-11.2c0.7-1,0.4-2.4-0.6-3.1
	c-0.1,0-0.1-0.1-0.2-0.1L1.7,60.4c-1.1-0.6-1.4-1.9-0.8-3c0.2-0.3,0.5-0.6,0.8-0.8l11.8-6.7c1.1-0.6,1.4-1.9,0.8-3
	c0-0.1-0.1-0.1-0.1-0.2L6.5,35.6c-0.7-1-0.4-2.4,0.6-3.1c0.3-0.2,0.7-0.4,1.1-0.4l13.5-0.9c1.2-0.1,2.1-1.1,2.1-2.3
	c0-0.1,0-0.1,0-0.2l-2.1-13.4c-0.2-1.2,0.6-2.3,1.8-2.5c0.4-0.1,0.8,0,1.2,0.1l12.6,5.1c1.1,0.5,2.4-0.1,2.9-1.2
	c0-0.1,0-0.1,0.1-0.2l3.9-13c0.3-1.2,1.6-1.8,2.7-1.5c0.4,0.1,0.7,0.3,1,0.6l9.1,10c0.8,0.9,2.2,1,3.1,0.1c0.1,0,0.1-0.1,0.1-0.1
	L69.3,2.6z"
            />
        </svg>
    );
};

export default Burst12;
